// Translations
import accessKeyManagingDialog from '../components/access-key-managing-dialog/translations/de'

// Translation: Model > Access key manager (German)
export default Object.freeze({
	actions: {
		create: {
			hint: '',
			text: ''
		}
	},
	components: { accessKeyManagingDialog }
})
